import config from "../config.js";
import RequestManager from "./request.js";

export default class Client {
    id;
    ADELI;
    email;
    idtypecontrat;
    nom;
    prenom;
    tel;
    adresse1;
    adresse2;
    ville;
    code_postal;
    nombre_de_postes;
    debut_contrat;
    dateDeFinDansBD;
    fin_contrat
    dateDeDebutDePeriode;
    dateDeFinDePeriode
    listAttribut;
    nbAttribut;
    debut_periode;
    fin_periode;
    etat_contrat;
    Chemin_icone_provisoire;
    Chemin_icone;
    constructor(obj) {

    }

    static async getClientWithEmail(email) {
        if (email == null) {
            console.warn("EMAIL == null");
            return Promise.resolve({});
        } else {
            let urlgetClientWithEmail = `${config.urlBackEnd}Client/getClientWithEmail?email=${email}`;
            return await RequestManager.get(urlgetClientWithEmail)
                .then(response => {
                    console.log("Infos contrat : ", response);
                    return response;
                })
                .catch(error => console.error(" error on Client.getClientWithEmail(email) ", error));
        }
    }

    static async postUpdateInfosClient(data) {
        if (!data) {
            console.warn('DATA == null');
            return Promise.resolve({});
        } else {
            let url = `${config.urlBackEnd}Client/update`;
            return await RequestManager.post(url, data)
                .then(response => {
                    console.log('Données mises à jour : ', response);
                    return response;
                })
                .catch(error => console.error("Erreur sur Client.update(data) ", error));
        }
    }


    
}
